import { useCallback, useState } from 'react';
import { ROUTES } from './../constants/index';

export const useSearchOverlay = () => {
  const [overlayOpen, setOverlayOpen] = useState(false);
  const [value, setValue] = useState('');
  const [focused, setFocused] = useState(false);

  const closeOverlay = useCallback(() => {
    setOverlayOpen(false);
    setValue('');
    setFocused(false);
  }, []);

  const openOverlay = useCallback(() => {
    setOverlayOpen(true);
  }, []);

  const submitSearch = useCallback(() => {
    const q = value.trim();
    if (!q) return;

    window.location.href = `${ROUTES.SEARCH}/#q=${encodeURIComponent(q)}`;
    closeOverlay();
  }, [value, closeOverlay]);

  return {
    overlayOpen,
    value,
    focused,
    setValue,
    setFocused,
    openOverlay,
    closeOverlay,
    submitSearch,
  };
};
